import React from 'react'

import { useModalContext } from './ModalContext'

type ModalContextButtonProps = {
  children: JSX.Element
  onOk: () => void
  onCancel?: () => void
  disabled: boolean
}

const ModalContextButton = ({
  children,
  onOk,
  onCancel,
  disabled,
}: ModalContextButtonProps) => {
  const modalContext: any = useModalContext()

  const handleOnClick = async (e) => {
    e.preventDefault()
    if (disabled) return

    const result = await modalContext.openModal()
    if (result) onOk()
    else if (onCancel != null) onCancel()
  }

  return (
    <a href="#" onClick={handleOnClick}>
      {children}
    </a>
  )
}

export default ModalContextButton
